module.exports = __webpack_public_path__ + "static/media/Grenette-SemiBold-Pro.65fd9794.woff";